<template>
    <div v-if="appData.terminatedContract" class="default-message" v-t="'message.error_contract_termination'">
    </div>
    <div v-else class="talk-panel">
            <table height="100%" width="100%" cellpadding=0 cellspacing=0>
            <tr height="55px">
                <td colspan=2>
                    <div class="search">
                        <div class="serarch-contents">
                            <div class="date-picker">
                                <span v-t="'message.item_date'"></span>
                                <el-date-picker
                                    v-model="date"
                                    type="date"
                                    prefix-icon="noicon"
                                    clear-icon="noicon"
                                    placeholder="">
                                </el-date-picker>
                            </div>
                            <div class="time-picker">
                                <span v-t="'message.item_time'"></span>
                                <el-time-select
                                    v-model="startTime"
                                    prefix-icon="noicon"
                                    clear-icon="noicon"
                                    :picker-options="{start: '00:00', step: '00:30', end: '24:00', maxTime: endTime}"
                                    placeholder="">
                                </el-time-select>
                                <span>-</span>
                                <el-time-select
                                    v-model="endTime"
                                    prefix-icon="noicon"
                                    clear-icon="noicon"
                                    :picker-options="{start: '00:00', step: '00:30', end: '24:00', minTime: startTime}"
                                    placeholder="">
                                </el-time-select>
                            </div>
                            <div class="display-target">
                                <span>{{ selectedItemType }}</span>
                                <div class="display-tags" v-if="selected.length > 0">
                                    <div class="selected-tag" v-if="isTalkgroup">
                                        <span>{{ selected[0].data.label }}</span>
                                        <span class="closeTag" @click="deleteUserTag(selected[0])">×</span>
                                    </div>
                                    <div class="p2p-tags" v-else>
                                        <div class="selected-tag">
                                            <span>{{ selected[0].data.label }}</span>
                                            <span class="closeTag" @click="deleteUserTag(selected[0])">×</span>
                                        </div>
                                        <div class="peer-user" v-if="selected.length == 2">
                                            <button class="transparent-button" @click="swapUserTag()"><img class="bidirectional" src="../assets/icon_mutual.svg"></img></button>
                                            <div class="selected-tag">
                                                <span>{{ selected[1].data.label }}</span>
                                                <span class="closeTag" @click="deleteUserTag(selected[1])">×</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="itemheader">
                <td width="50%" height="100%">
                    <div class="inner-panel">
                        <div class="objectTree" v-if="showTree">
                            <object-tree
                                v-bind:initialData="appData.tenantList"
                                v-bind:showAdminUser="false"
                                @on-selectnode="handleOnSelectNode"
                                ref="objectTree">
                            </object-tree>
                        </div>
                    </div>
                </td>
                <td width="50%">
                    <div id="record-list-panel" class="inner-panel">
                        <div class="scrollable">
                            <talkrecord-list
                                v-bind:appData="appData"
                                v-bind:date="date"
                                v-bind:startTime="startTime"
                                v-bind:endTime="endTime"
                                v-bind:languageIndex="languageIndex"
                                v-bind:selected="selected"
                                v-bind:isTalkgroup="isTalkgroup"
                                :recordListPanelHeight="recordListPanelHeight">
                            </talkrecord-list>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import constants from "./constants.js";
import commonUtil from "./commonutil.js";
import ObjectTree from "./ObjectTree.vue"
import TalkrecordList from "./TalkrecordList.vue";
import ca from "element-ui/src/locale/lang/ca";

export default {
    data () {
        return {
            date: new Date(),
            startTime: '00:00',
            endTime: '24:00',
            selected: [],
            isTalkgroup: true,
            showTree: true,
            selectedItemType: null,
            languageIndex: 0,
            recordListPanelHeight: 0,
        }
    },
    methods: {
        handleOnSelectNode(elnode) {
            switch (elnode.node.data.type) {
                case constants.OBJECT_NODE:
                    return ;
                case constants.OBJECT_USER:
                case constants.OBJECT_ASSISTANT:
                case constants.OBJECT_CUSTOM_ASSISTANT:
                    if (this.isTalkgroup) {
                        this.selected = [];
                        this.isTalkgroup = false;
                        this.selectedItemType = "";
                    }

                    if (this.selected.length == 0) {
                        this.selectedItemType = commonUtil.getMessageText(this.$i18n,"item_user");
                        this.selected.push(elnode.node);
                    } else if (this.selected.length == 1) {
                        if (this.selected[0] !== elnode.node) {
                            this.selected.push(elnode.node);
                        }
                    } else if (this.selected.length == 2) {
                        if (this.selected[0] == elnode.node) {
                            commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_select_same_user"));
                            return;
                        }
                        this.selected.splice(1,1);
                        this.selected.push(elnode.node);
                    }
                    return ;
                case constants.OBJECT_TALKGROUP:
                    this.selected = [];
                    this.selectedItemType = commonUtil.getMessageText(this.$i18n,"item_group");
                    this.selected.push(elnode.node);
                    this.isTalkgroup = true;
                    return ;
            }
        },
        swapUserTag() {
            this.selected.splice(0, 2, this.selected[1], this.selected[0]);
        },
        deleteUserTag(node) {
            var self = this;
            this.selected.some(function(value, i){
                if (value == node) {
                    self.selected.splice(i, 1);
                }
                if (self.selected.length == 0) {
                    self.selectedItemType = "";
                }
            });
        },
        setLanguageIndex() {
            let countryCode = this.appData.countryCodeAlpha3;
            let language = commonUtil.getLanguageIndexList(this.$i18n.locale).filter(function (item, index) {
                if (item.countryCode.indexOf(countryCode) >= 0) return true;
            });
            if (language.length == 0) {
                this.languageIndex = 2;
            } else {
                this.languageIndex = language[0].value;
            }
        },
        setRecordListPanelHeight() {
            // height of record list panel uses as max-height parameter of el=table
            let el = document.getElementById('record-list-panel');
            this.recordListPanelHeight = el.clientHeight - 50;
        }
    },
    created () {
        this.setLanguageIndex();
        let self = this;
        let timer = null;
        window.addEventListener( 'resize', function() {
            // resize event will fired during resize. (it not fired only at resize has finished)
            if (timer != null) {
                clearTimeout(timer);
            }
            timer = setTimeout(function() {
                self.setRecordListPanelHeight();
            } ,200);
        }, false );
    },
    mounted() {
        this.setRecordListPanelHeight();
    },
    components: {
        ObjectTree,
        TalkrecordList
    },
    watch: {
        'appData.tenantList'(newVal) {
            this.showTree = false;
            this.$nextTick(() => {
                this.showTree = true;
                this.setLanguageIndex();
            });
        },
        '$route' (to, from) {
            if (to.name == "Talk") {
                this.$refs.objectTree.resetCurrentNode(true);
                this.selected = [];
                this.data = new Date();
                this.startTime = '00:00';
                this.endTime = '24:00';
                this.selectedItemType = null;
            }
        }
    },
    props: ['appData']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>

<style scoped>

table {
    border-collapse: collapse;
}

tr.itemheader {
    border-top: 1px solid #eeeeee;
}

.talk-panel {
    height: 100%;
    background-color: #ffffff;
}

.inner-panel {
    position:relative;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
    background-color: #ffffff;
}

.scrollable {
    overflow: auto;
    position: absolute;
    top: 0;
    right:0;
    bottom: 0;
    left: 0;
}

select {
    height: 40px;
}

.search {
    width: 100%;
    background-color: #ecf1fa;
    display: table;
}

.serarch-contents {
    display: table-cell;
    vertical-align:middle;
}

.date-picker {
    display: inline-block;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.time-picker {
    display: inline-block;
    padding-left: 20px;
}

.display-target {
    display: inline-block;
    padding-left: 20px;
}

.display-tags {
    display: inline-block;
}

.p2p-tags {
    display: inline-block;
}

.peer-user {
    display: inline-block;
}

.selected-tag {
    display: inline-block;
    border: 1px solid;
    border-radius: 30px;
    border-color: #5171cb;
    background-color: #ffffff;
    color: #5171cb;
    margin: 5px;
    padding: 6px;
    padding-left: 10px;
}
.selected-tag > .closeTag {
    cursor: pointer;
    border-radius: 4px;
    margin: 4px;
}
.selected-tag > .closeTag:active {
    background-color: gray;
}

.date-picker >>> .el-input__inner {
    background-image:url('../assets/icon_calendar.svg');
    background-repeat:no-repeat;
    background-position-x: 10px;
    background-position-y: center;
    background-size: 16px 16px;
    height: 35px;
}

.date-picker > .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 140px;
}

.time-picker >>> .el-input__inner {
    background-image:url('../assets/icon_clock.svg');
    background-repeat:no-repeat;
    background-position-x: 10px;
    background-position-y: center;
    background-size: 16px 16px;
    height: 35px;
}

.time-picker > .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100px;
}

.time-select-item {
    text-align: center!important;
}

.time-select-item.selected {
    color: #333B48!important;
}

.el-input--prefix .el-input__inner {
    padding: 0 8px !important;
    text-align: center !important;
}

</style>
